import { useEffect, useState } from 'react';

/**
 * Zentraler Z-Index-Stack für (auch verschachtelte) Modale. Jeder geöffnete
 * Dialog erhält einen höheren Z-Index als der darunterliegende, ohne dass die
 * Seiten selbst feste z-Werte vergeben müssen. Basis liegt bewusst weit über
 * dem bisherigen Maximum (90) aus src/constants/modalLayers.ts.
 */
const BASE_Z = 1000;
const STEP = 10;
let openCount = 0;

export interface ModalStackState {
  /** Zugewiesener z-index für Backdrop + Panel dieses Dialogs. */
  zIndex: number;
  /** true, solange dieser Dialog der oberste im Stack ist. */
  isTop: boolean;
}

export function useModalStack(open: boolean): ModalStackState {
  const [state, setState] = useState<ModalStackState>({ zIndex: BASE_Z, isTop: true });

  useEffect(() => {
    if (!open) return;
    openCount += 1;
    const myLevel = openCount;
    setState({ zIndex: BASE_Z + myLevel * STEP, isTop: true });

    return () => {
      openCount -= 1;
    };
  }, [open]);

  return state;
}
